module.exports = __webpack_public_path__ + "static/media/Line 28.74b4e478.svg";